import React, { Component } from 'react';
import styled from 'styled-components';

const Wrapper = styled.div`
  width: 100%;
  display: flex;
  margin: 10px 0;

  > button {
    border-radius: 0;
    width: calc(100% / 2);
  }
  > button:first-child {
    border-radius: 3px 0 0 3px;
  }
  > button:last-child {
    border-radius: 0 3px 3px 0;
  }
`;

export class ButtonGroup extends Component {
  render() {
    const { children } = this.props;

    return (
      <Wrapper>
        {children}
      </Wrapper>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/ButtonGroup.js